import ApiService from "@/core/services/ApiService";
import EndpointService from "@/core/services/Endpoints";
import JwtService from "@/core/services/JwtService";
import ImpersonationService from "@/core/services/ImpersonationService";
import {Actions, Mutations} from "@/store/enum/StoreEnums";

// aynı anda birden fazla auth/check isteği gitmesin (rota koruması + App.vue)
let checkRequest = null;

export default {
    state: () => ({
        errors: [],
        user: {},
        isAuthenticated: !!JwtService.get('token')
    }),
    getters: {
        currentUser(state) {
            return state.user;
        },
        isUserAuthenticated(state) {
            return state.isAuthenticated;
        },
        getErrors(state) {
            return state.errors;
        }
    },
    actions: {
        [Actions.LOGIN](context, credentials) {
            ApiService.resetBaseUrl();

            return new Promise((resolve, reject) => {
                return ApiService.axios.post("/auth", credentials).then(({data}) => {
                    context.commit(Mutations.SET_AUTH, data);
                    JwtService.save('tokenType', data.token.type);
                    JwtService.save('token', data.token.token);
                    ApiService.setHeader();
                    resolve(data);
                }).catch(({response}) => {
                    context.commit(Mutations.SET_ERROR, [response.data.message]);
                    reject();
                });
            });
        },
        [Actions.LOGOUT](context) {
            context.commit(Mutations.PURGE_AUTH);
        },
        [Actions.VERIFY_AUTH](context) {
            if (!JwtService.get('token')) {
                context.commit(Mutations.PURGE_AUTH);
                return;
            }

            if (checkRequest) {
                return checkRequest;
            }

            ApiService.setHeader();
            // son çağrılan endpoint developer grubundaysa baseURL orada kalmış olur
            ApiService.resetBaseUrl();

            checkRequest = new Promise((resolve) => {
                ApiService.axios.get("/auth/check").then(({data}) => {
                    if (data.status) {
                        context.commit(Mutations.SET_AUTH, data);
                    } else {
                        context.commit(Mutations.PURGE_AUTH);
                    }
                    resolve(data);
                }).catch(() => {
                    context.commit(Mutations.PURGE_AUTH);
                    resolve(null);
                }).finally(() => {
                    checkRequest = null;
                });
            });

            return checkRequest;
        },
    },
    mutations: {
        [Mutations.SET_ERROR](state, error) {
            state.errors = error;
        },
        [Mutations.SET_AUTH](state, data) {
            state.isAuthenticated = true;
            state.user = data.session;
            state.errors = [];
        },
        [Mutations.SET_USER](state, user) {
            state.user = user;
        },
        [Mutations.PURGE_AUTH](state) {
            state.isAuthenticated = false;
            state.user = {};
            state.errors = [];
            JwtService.destroy('token');
            JwtService.destroy('tokenType');
            ImpersonationService.clear();
        }
    }
};
